import {Cookies, Module} from '@mamdev/cad.static-next-lib';

export default class Messagebar extends Module {
  /** Attach root DOM element. */
  static override attachTo(root: HTMLElement): Messagebar {
    return new Messagebar(root);
  }

  constructor(root: HTMLElement) {
    super(root);
    this.name_ = 'messagebar';
  }

  /** Starts the module. */
  override start(): void {
    try {
      if (this.root_.className.includes('error')) {
        this.log('Removing user cookie...');
        Cookies.removeItem('ushallpass', '/');
      }
    } catch (e) {
      this.logUnknownError(e);
    }
  }
}
